//import PartsCatalogueService from './PartsCatalogueService'
//import PartsCatalogueRoutes from './route-types'
import StoreUtil from '@/store/utils'
import DeepDiff from 'deep-diff'
//import { md5 } from '@/components/crypto'

const tag = 'partscatalogue'

const state = {
  returnRoute: {},
  baseIndex: 0,
  currentIndex: 0,
  snapshots: []
}

const getters = {
  returnRoute: state => state.returnRoute,
  snapshots: state => state.snapshots,
  baseSnapshot: state => state.snapshots[state.baseIndex],
  currentSnapshot: state => state.snapshots[state.currentIndex],
  snapshotDiff: state => {
    if (state.snapshots[state.baseIndex] && state.snapshots[state.currentIndex]) {
      return DeepDiff.diff(state.snapshots[state.baseIndex], state.snapshots[state.currentIndex])
    } else {
      return null
    }
  }
}

const actions = {
  // async getStoreItem({ commit }, id, filter) {
  //   // const entity = StoreUtil.getStorage(id, tag) || (await PartsCatalogueService.getEntity(id, ''))
  //   // The following for refreshing data from WebApi regardless
  //   console.log(id, filter)
  //   let entity = StoreUtil.getStorage(id, tag)
  //   if (!entity || (entity && !entity.isNew)) {
  //     const hash = entity ? md5(JSON.stringify(entity)) : ''
  //     const data = await PartsCatalogueService.getEntity(id, hash, filter)
  //     if (data) {
  //       console.log('from WebApi')
  //       entity = data
  //     } else {
  //       console.log('from sessionStorage')
  //     }
  //   }
  //   StoreUtil.setStorage(entity.partsCatalogNo, tag, entity)
  //   commit('saveInitialSnapshots', entity)
  // },
  saveSnapshot({ commit }, entity) {
    commit('saveSnapshot', entity)
  },
  clearSnapshots({ commit }, id) {
    StoreUtil.removeStorage(id, tag)
    commit('clearSnapshots')
  },
  setReturnRoute({ commit }, route) {
    commit('setReturnRoute', route)
  }
}

const mutations = {
  saveInitialSnapshots(state, entity) {
    state.snapshots = []
    state.snapshots.splice(0, 1, entity)
    state.snapshots.splice(1, 1, entity)
    state.currentIndex = state.snapshots.length - 1
  },
  saveSnapshot(state, entity) {
    state.snapshots.splice(state.currentIndex, 1, entity)
  },
  clearSnapshots(state) {
    state.snapshots = []
    state.baseIndex = 0
    state.currentIndex = 0
  },
  setReturnRoute(state, route) {
    state.returnRoute = route
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
